import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from './PerinHealthModelSlice'; 
import styles from './PerinHealthModel.module.css';

const PerinHealthModal = ({ modalId, handleButtonClick }) => {

    const dispatch = useDispatch();
    const {activeModalId, show, header, message, buttons} = useSelector(state => state.perinHealthModal);
    if (!show || activeModalId !== modalId) return null;

    return (
        <Modal style={{fontFamily:"Roboto"}} show={show} onHide={() => dispatch(closeModal())} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message && <div style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: message }} />}
            </Modal.Body>
            <Modal.Footer>
                {buttons && buttons.map((button, index) => (
                    <Button 
                        key={index} 
                        variant={button.variant}
                        className={button.variant !== 'secondary' ?  styles.ModelButton : styles.SecondaryButton}
                        onClick={() => handleButtonClick && handleButtonClick(button.onClickKey)}
                    >
                        {button.label}
                    </Button>
                ))}
            </Modal.Footer>
        </Modal>
    );
};

export default PerinHealthModal;
